import isToday from '@/utils/is-today';
import isTomorrow from '@/utils/is-tomorrow';

const padDates = (date) => {
  const day = date
    .getDate()
    .toString()
    .padStart(2, '0');
    const month = (date.getMonth() + 1)
    .toString()
    .padStart(2, '0');
  const year = date.getFullYear();

  return { day, month, year };
}

export const ddmmyyyy = (date, delimiter = '.') => {
  const { day, month, year } = padDates(date);

  return `${day}${delimiter}${month}${delimiter}${year}`;
};

export const ddmm = (date, delimiter = '.') => {
  const { day, month } = padDates(date);

  return `${day}${delimiter}${month}`;
};

export const dd = (date) => {
  const { day } = padDates(date);

  return `${day}`;
};

export const dateToVerbal = (date = new Date()) => isToday(date)
  ? 'сегодня'
  : isTomorrow(date)
    ? 'завтра'
    : ddmmyyyy(date);
